<div class="surface-card p-5 m-3 shadow-1 border-round">
  <div class="font-medium text-2xl text-700 mb-3">
    <i class="pi pi-dollar"></i>
    Módulo de Cambio
  </div>
  <form [formGroup]="fg">
    <ul class="list-none p-0 m-0">
      <li
        class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap"
      >
        <div class="text-500 w-2 md:w-5 font-medium">Total Venta</div>
        <div class="text-900 w-full ml-1 md:w-6 md:flex-order-0 flex-order-1">
          S/. {{ amountSale }}
        </div>
      </li>
      <li
        class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap"
      >
        <div class="text-500 w-2 md:w-4 font-medium">Pago Cliente</div>
        <div class="text-900 w-full ml-1 md:w-6 md:flex-order-0 flex-order-1">
          <input
            pInputText
            formControlName="amountClient"
            type="number"
            class="size-1"
          />
          <div
            *ngIf="
              fg.get('amountClient').invalid &&
              (fg.get('amountClient').dirty || fg.get('amountClient').touched)
            "
            class="p-invalid"
          >
            <div *ngIf="fg.get('amountClient').errors?.required">
              <small class="p-error">No puede quedar vacio.</small>
            </div>
            <div *ngIf="fg.get('amountClient').errors?.min">
              <small class="p-error"
                >Debe tener un valor minimo de {{ amountSale }}.</small
              >
            </div>
          </div>
        </div>
      </li>
      <li
        class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap"
      >
        <div class="text-500 w-2 md:w-5 font-medium">Cambio</div>
        <div class="text-900 w-full ml-1 md:w-6 md:flex-order-0 flex-order-1">
          S/. {{ moneyBack.toFixed(2) }}
        </div>
      </li>
    </ul>
  </form>
</div>
